import { SxProps } from '@mui/material';

export const geoLocRequestViewLinkSX: SxProps = {
	color: 'secondary.main',
	cursor: 'pointer',
};

export const geoLocRequestViewContainerSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: 'grey.50',
	borderRadius: '3px',
	color: 'grey.500',
	p: '10px',
	gap: '10px',
};

export const geoLocRequestViewListSX: SxProps = {
	py: 0,
};

export const geoLocRequestViewListItemSX: SxProps = {
	px: '10px',
	pt: 0,
	pb: '4px',
	'&::before': {
		content: '"•"',
		marginRight: 1,
		display: 'inline-block',
	},
};

export const geoLocRequestBtnSX: SxProps = {
	height: 41.56,
};

export const geoLocRequestPrivacyLinkSX: SxProps = {
	color: 'secondary.main',
	pb: '10px',
};
